import type { FaireProductEntity } from "../../entity_types/product";

export const p_swcgq8n95s: FaireProductEntity = {
  token: "p_swcgq8n95s",
  type: "product",
  name: "Horizon Ceramic Handmade Mug - 16oz",
  brandToken: "b_7jc8fy9bgs",
  brandName: "Nova Ceramics Travel Mugs",
  imageUrl:
    "https://cdn.faire.com/fastly/2f6d2c5306bbf8c83381d376f8ff76cdbc9e88b2d852dab7301e521924bad5e4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4a8fb1b217820b7aa7ec902f665894d66137df0a147125af9a9c7b65dda77575.jpeg",
    "https://cdn.faire.com/fastly/e54d1948a1885085ce40eb2f4526554d6155a7d3c2b07f73b7792e01553988ce.jpeg",
    "https://cdn.faire.com/fastly/33bd67c8fdfed1c2bb84241b91a2308a14f9080258d906ff7d79b122b46aabde.jpeg",
    "https://cdn.faire.com/fastly/4f41f6d26657040192db378c500527a3cec1906ba3acc7c1cd4031707fd63760.jpeg",
    "https://cdn.faire.com/fastly/7e26dc6665cec1b78502c202c25534bd0b0d0735f6a9ea38bb544c718b92c5bf.jpeg",
    "https://cdn.faire.com/fastly/af2d483b67190f694bd21fc11da7ecf47effd7bac23df4c8ff38a97cf9d5a774.jpeg",
    "https://cdn.faire.com/fastly/0e2c98bd7fd47e8587a50844b81cf84ac4d27f79f030a2cee8c8cb14ce49bc8b.jpeg",
  ],
  priceDollars: 28,
  description:
    "The serene beauty of nature's horizon. A light purple and maroon glaze melt into a refined grey base, mirroring the calming hues of a twilight sky.\n\nEach of our handglazed cups and mugs turn your morning sip into a mindful pause, while enhancing the aroma of your favorite drink. Hand-glazed with a one-of-a-kind motif, no two mugs are exactly alike.\n\nPerfect for slow mornings or cozy afternoons, our handmade mug is crafted from high-quality stoneware to deliver the purest taste with every sip. Its oversized, easy-hold handle is thoughtfully designed to feel balanced and secure in your hand, making every coffee moment feel comfortable and effortless.\n\nCapacity: 16 ounces / 475ml Size: 3.14 x 4.3 Inches / 8 x 11cm\n\n- Premium stoneware ceramic for durability and pure flavour\n- Oversized, comfortable handle for an easy grip\n- A beautiful statement piece, perfect for gifting\n- Microwave Safe & Dishwasher Safe",
  tags: [],
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:50.403Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
